export const HOT_FOLDER = "HOT_FOLDER";
export const WORKING_COPY = "WORKING_COPY";
